import { type CSSProperties } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeAllModals } from 'reducers/modalReducer';

import {
  JBEnvironmentId,
  JBErrorDto,
  JBErrorView,
  JBErrorViewTechnicalInformation,
} from '@bjb-gcrm/gcrm-frontend-components';
import { ZfDialog, ZfDialogContent } from '@zafire/react';
import { AxiosError, isAxiosError } from 'axios';
import { RootState } from '../../store';

type Props = {
  technicalInfo: Partial<JBErrorViewTechnicalInformation> &
    Pick<JBErrorViewTechnicalInformation, 'title' | 'userErrorMessage'>;
  httpError?: unknown;
  handleClose?: () => void;
  okHandler?: () => void;
};

const APP_ID = 'pco-product-service';
const COMPONENT_ID = 'pco-product-service-frontend-view';

export const JBErrorModalWrapper = ({ technicalInfo, httpError, handleClose, okHandler }: Props) => {
  const axiosError = isAxiosError<JBErrorDto>(httpError) ? (httpError as AxiosError<JBErrorDto>) : undefined;
  const httpProblem = axiosError?.response?.data;
  const userId = useSelector((state: RootState) => state.appConfig.userId);

  const dispatch = useDispatch();

  const handleTopCloseButton = () => {
    if (okHandler) {
      okHandler();
    } else if (handleClose) {
      handleClose();
    } else {
      dispatch(closeAllModals());
    }
  };

  return (
    <ZfDialog
      show={true}
      size="medium"
      disableLightDismiss
      data-testid="error-dialog"
      onDialogClose={handleTopCloseButton}
    >
      <ZfDialogContent style={{ '--padding': '0' } as CSSProperties}>
        <JBErrorView
          handleClose={handleTopCloseButton}
          httpInfoAxiosError={axiosError}
          technicalInfo={{
            details:
              axiosError?.message || 'Unknown technical details: the developer forgot to specify this information',
            userInfo: {
              userId: userId || 'Unauthorized',
            },
            envInfo: {
              envId: httpProblem?.env as JBEnvironmentId,
              appId: httpProblem?.app || APP_ID,
              componentId: httpProblem?.component || COMPONENT_ID,
            },
            ...technicalInfo,
          }}
        />
      </ZfDialogContent>
    </ZfDialog>
  );
};
